import React from 'react';
import moment from 'moment';
import { Field, reduxForm, formValueSelector, getFormSyncErrors } from 'redux-form';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Accordion from 'react-bootstrap/Accordion';
import FormGroup from 'react-bootstrap/FormGroup';
import FormControl from 'react-bootstrap/FormControl';
import PhoneInput from 'react-phone-input-2';
import Loader from '../../Common/Loader/Loader';
import SwitchButton from '../../Common/Switch/SwitchButton';
import PlaceGeoSuggest from '../../Common/PlaceGeoSuggest/PlaceGeoSuggest';
import TextToolTipContent from '../../Common/TextToolTipContent/TextToolTipContent';
import ScheduleBookingModal from '../ScheduleBooking/ScheduleBookingModal';
import { openScheduledBookingModal } from '../../../actions/siteadmin/modalActions';
import messages from '../../../locale/messages';
import validate from './validate';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { scheduleDateSplitUp } from '../../../helpers/bookingHelper';
import { checkUserExists } from '../../../actions/siteadmin/ManualBooking/checkUserExists';
import { getBookingSubCategories } from '../../../actions/siteadmin/ManualBooking/getBookingSubCategories';
import AccordionArrow from '/public/Icons/accordionArrow.svg';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';
import n from 'react-phone-input-2/lib/style.css';
import bt from '../../../components/commonStyle.css';
import s from '../../../styles/phoneNumberInput.css'

class ManualBookingForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selected: false,
            bookingArrow: false,
        };
    }

    toggleSelected = () => {
        this.setState((prevState) => ({
            selected: !prevState.selected,
        }));
    }

    toggleArrowSelected = () => {
        this.setState((prevState) => ({
            bookingArrow: !prevState.bookingArrow
        }));
    }

    handleSelectSuggest = (data, value) => {
        const { change } = this.props;
        if (data) {
            if (data.addressComponents) {
                let viewport, sw_lat, sw_lng, ne_lat, ne_lng, northEast, southWest;
                viewport = data?.viewport;
                northEast = viewport?.high;
                southWest = viewport?.low;
                sw_lat = southWest?.latitude;
                sw_lng = southWest?.longitude;
                ne_lat = northEast?.latitude;
                ne_lng = northEast?.longitude;
                change('sw_lat', sw_lat);
                change('sw_lng', sw_lng);
                change('ne_lat', ne_lat);
                change('ne_lng', ne_lng);
            }
            change('location', value);
            change('lat', data['location']['latitude']);
            change('lng', data['location']['longitude']);
        } else {
            ['location', 'lat', 'lng', 'sw_lat', 'sw_lng', 'ne_lat', 'ne_lng'].map((field) => change(field, null))
        }
    }

    toggleStepOne = () => this.props.change('isStepOneClosed', !this.props.isStepOneClosed);

    toggleStepTwo = () => this.props.stepTwoEnabled && this.props.change('isStepTwoClosed', !this.props.isStepTwoClosed);

    renderPlacesSuggest = ({ input, id, label, meta: { touched, error }, initialValue, className, disabled, formGroupClass }) => {
        const { formatMessage } = this.props.intl;
        return (
            <FormGroup className={formGroupClass}>
                <div> <label className={bt.commonLabelText}>{label}</label> </div>
                <PlaceGeoSuggest
                    {...input}
                    label={label}
                    handleSelectSuggest={this.handleSelectSuggest}
                    disabled={disabled}
                    initialValue={initialValue}
                    inputClass={cx(bt.formControlInput, 'form-control')}
                    id={id}
                />
                {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        )
    }

    renderSelectField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, children, disabled, formGroupClass }) => {
        const { formatMessage } = this.props.intl;
        const { touch, categories } = this.props;
        return (
            <Form.Group className={formGroupClass}>
                <label className={bt.commonLabelText}>{label}</label>
                <Form.Control
                    as="select"
                    {...input}
                    placeholder={placeholder}
                    className={fieldClass}
                    disabled={disabled}
                >
                    <option value={''}>
                        {formatMessage(messages.category)}
                    </option>
                    {categories?.results?.map(category => (
                        <option key={category?.id} value={category?.id}
                            onChange={(e) => touch('categoryId')}
                        >
                            {category?.name}
                        </option>
                    ))}
                </Form.Control>
                {touched && error && (<span className={bt.errorMessage}>{formatMessage(error)}</span>)}
            </Form.Group>
        );
    };

    resetStepTwoFields = () => {
        const { change } = this.props;
        change('isPreferredProvider', false);
        change('orderData', null);
        change('stepTwoCompleted', false);
        change('preferredPartnerLat', null);
        change('preferredPartnerLng', null);
        change('isRandomProviderSelection', true);
    }

    switchBookingType = (bookingType) => {
        const { change, bookingType: previousBookingType } = this.props;
        if (previousBookingType == 1 && bookingType) {
            change('scheduleFrom', null);
        }
        change('bookingType', bookingType ? 2 : 1);
    };

    openScheduledBooking = () => {
        const { openScheduledBookingModal } = this.props;
        openScheduledBookingModal();
    }

    renderUserInput = () => {
        const { stepTwoCompleted, userId } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <div className='oneColumnGrid'>
                <div className='twoColumnGrid'>
                    <Field
                        name="firstName"
                        type="text"
                        component={InputFieldComponent}
                        inputClass={bt.formControlInput}
                        label={formatMessage(messages.firstName)}
                        placeholder={formatMessage(messages.firstName)}
                        disabled={userId || stepTwoCompleted}
                    />
                    <Field
                        name="lastName"
                        type="text"
                        component={InputFieldComponent}
                        inputClass={bt.formControlInput}
                        label={formatMessage(messages.lastName)}
                        placeholder={formatMessage(messages.lastName)}
                        disabled={userId || stepTwoCompleted}
                    />
                </div>
                <Field
                    name="email"
                    type="text"
                    component={InputFieldComponent}
                    inputClass={bt.formControlInput}
                    label={formatMessage(messages.emailText)}
                    placeholder={formatMessage(messages.emailText)}
                    disabled={userId || stepTwoCompleted}
                />
            </div>
        );
    };

    renderDate = ({ input, label, placeholder, meta: { touched, error }, fieldClass, disabled, formGroupClass }) => {
        const { formatMessage, locale } = this.props.intl;
        const { openScheduledBookingModal } = this.props;
        let showFormat = input?.value && moment(input?.value).locale('en').format('A').toLocaleLowerCase();
        let showFromDate = input?.value && `${moment(input?.value).format("DD/MM/YYYY, h:mm")} ${formatMessage(messages[showFormat])}`;
        let showDate = moment(input?.value).locale(locale).format(`ddd, MMM D, [${formatMessage(messages.at)}] h:mm A`);
        return (
            <FormGroup className={formGroupClass}>
                <label className={bt.commonLabelText}>{label}</label>
                <Form.Control placeholder={placeholder} onMouseDown={openScheduledBookingModal} value={showFromDate} className={fieldClass} disabled={disabled}>
                </ Form.Control>
                {!error && <span className={cx(bt.bookingScheduleOnText)}>{`${formatMessage(messages.bookingScheduleOn)} ${showDate}`}</span>}
                {touched && error && (<span className={bt.errorMessage}>{formatMessage(error)}</span>)}
            </FormGroup>
        );
    };

    checkUserExists = async () => {
        const { checkUserExists, phoneNumber, phoneDialCode, fieldErrors } = this.props;
        let errors = Object.assign({}, (fieldErrors || {}));

        if (errors.phoneNumber) {
            showToaster({ messageId: 'invalidNumber', toasterType: 'error' })
        } else {
            await checkUserExists({ phoneNumber, phoneDialCode })
        }
    }

    onChangePhoneNumber = (value, event) => {
        const { change } = this.props;
        let phoneNumber = value.replace(/[^0-9]+/g, '').slice(event.dialCode.length);
        change('phoneCountryCode', (event.countryCode.toUpperCase()));
        change('phoneDialCode', `+${event.dialCode}`);
        change('phoneNumber', phoneNumber);
        change('phoneFieldValue', value);
    };

    getOrderDetails = async () => {
        const { change, touch, fieldErrors } = this.props;
        const { categoryId, lat, lng, getBookingSubCategories } = this.props;
        let keys = Object.keys(fieldErrors || {});
        if (keys.length > 0) {
            touch(...keys)
        } else {
            getBookingSubCategories({ categoryId: Number(categoryId), lat, lng }, 'stepTwo')
            change('stepTwoCompleted', true);
        }
    }

    render() {
        const { isStepTwoClosed, loaders, stepTwoEnabled, stepTwoCompleted, bookingType, scheduleFrom } = this.props;
        const { phoneFieldValue } = this.props;
        const { formatMessage, locale } = this.props.intl;
        const scheduleInitialValues = scheduleDateSplitUp(scheduleFrom);
        let showDate = moment(scheduleFrom).locale(locale).format(`ddd, MMM D, [${formatMessage(messages.at)}] h:mm A`);

        return (

            <div>
                <ScheduleBookingModal
                    initialValues={scheduleInitialValues}
                />
                <Form>
                    <Accordion defaultActiveKey="0" className='commonAccordionContainer'>
                        <Accordion.Toggle eventKey="0" className={cx('commonAccordionHeading darkModeAccordionHeading')} onClick={this.toggleSelected}>
                            {formatMessage(messages.phoneNumber)}
                            <span className='accordionArrow'>
                                <img src={AccordionArrow} alt="" className={cx(!this.state.selected ? 'accordionArrowDown' : 'accordionArrowUp')} />
                            </span>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0" className='commonAccordionBody'>
                            <div className='commonAccordionBodyWrapper'>
                                <div className='guideBookPhoneInput'>
                                    <PhoneInput
                                        value={phoneFieldValue}
                                        country={'us'}
                                        label={formatMessage(messages.phoneNumber)}
                                        onChange={this.onChangePhoneNumber}
                                        countryCodeEditable={false}
                                        disabled={stepTwoEnabled}
                                        disableDropdown={stepTwoEnabled}
                                        placeholder={formatMessage(messages.phoneNumber)}
                                    />
                                </div>
                                <div className='commonAccordionBtnContainer'>
                                    <Loader
                                        type={"button"}
                                        buttonType={"button"}
                                        show={loaders?.stepOne}
                                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                                        label={formatMessage(messages.next)}
                                        handleClick={this.checkUserExists}
                                        disabled={stepTwoEnabled}
                                    />
                                </div>
                            </div>
                        </Accordion.Collapse>
                    </Accordion>
                    {
                        stepTwoEnabled && !isStepTwoClosed &&
                        <Accordion defaultActiveKey="0" className='commonAccordionContainer commonAccordionInfoContainer'>
                            <Accordion.Toggle eventKey="0" className='commonAccordionHeading darkModeAccordionHeading' onClick={this.toggleArrowSelected}>
                                {formatMessage(messages.bookingDetails)}
                                <span className='accordionArrow'>
                                    <img src={AccordionArrow} alt="" className={cx(!this.state.bookingArrow ? 'accordionArrowDown' : 'accordionArrowUp')} />
                                </span>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0" className='commonAccordionBody'>
                                <div className='commonAccordionBodyWrapper'>
                                    <div className='oneColumnGrid'>
                                        {this.renderUserInput()}
                                        <div className='commonBookingSwitchContainer'>
                                            <TextToolTipContent label={formatMessage(messages.bookNow)} content={formatMessage(messages.bookNow)} />
                                            <div>
                                                <SwitchButton
                                                    checked={bookingType === 2}
                                                    onChange={this.switchBookingType}
                                                    handleDiameter={26}
                                                    disabled={stepTwoCompleted}
                                                />
                                            </div>
                                            <TextToolTipContent label={formatMessage(messages.schedule)} content={formatMessage(messages.schedule)} />
                                        </div>

                                        <Field
                                            name="categoryId"
                                            placeholder={formatMessage(messages.category)}
                                            component={this.renderSelectField}
                                            fieldClass={cx(bt.formControlSelect)}
                                            label={formatMessage(messages.category)}
                                            disabled={stepTwoCompleted}
                                            formGroupClass={bt.space0}
                                        />
                                        <Field
                                            name="location"
                                            component={this.renderPlacesSuggest}
                                            label={formatMessage(messages.locationName)}
                                            disabled={stepTwoCompleted}
                                            formGroupClass={bt.space0}
                                        />
                                        {bookingType == 2 &&
                                            <Field
                                                name="scheduleFrom"
                                                component={this.renderDate}
                                                label={formatMessage(messages.dateTime)}
                                                placeholder={formatMessage(messages.chooseDateTime)}
                                                fieldClass={cx(bt.formControlInput)}
                                                disabled={stepTwoCompleted}
                                                formGroupClass={bt.space0}
                                            />
                                        }
                                    </div>
                                    <hr className='commonAccordionDivider' />
                                    <div className='commonAccordionBtnContainer'>
                                        <Loader
                                            type={"button"}
                                            buttonType={"button"}
                                            show={loaders?.stepTwo}
                                            className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                                            label={formatMessage(messages[stepTwoCompleted ? 'editInfo' : 'next'])}
                                            handleClick={stepTwoCompleted ? this.resetStepTwoFields : this.getOrderDetails}
                                        />
                                    </div>
                                </div>
                            </Accordion.Collapse>
                        </Accordion>
                    }
                </Form>
            </div>

        )
    }
}

ManualBookingForm = reduxForm({
    form: 'ManualBookingForm',
    validate
})(ManualBookingForm);

const selector = formValueSelector('ManualBookingForm');

const mapState = (state) => ({
    isStepOneClosed: selector(state, 'isStepOneClosed'),
    isStepTwoClosed: selector(state, 'isStepTwoClosed'),
    stepTwoEnabled: selector(state, 'stepTwoEnabled'),
    stepTwoCompleted: selector(state, 'stepTwoCompleted'),
    bookingType: selector(state, 'bookingType'),
    phoneNumber: selector(state, 'phoneNumber'),
    phoneDialCode: selector(state, 'phoneDialCode'),
    loaders: selector(state, 'loaders'),
    phoneFieldValue: selector(state, 'phoneFieldValue'),
    scheduleFrom: selector(state, 'scheduleFrom'),
    fieldErrors: getFormSyncErrors('ManualBookingForm')(state),
    location: selector(state, 'location'),
    userId: selector(state, 'userId'),
    lat: selector(state, 'lat'),
    lng: selector(state, 'lng'),
    categoryId: selector(state, 'categoryId')
});

const mapDispatch = {
    checkUserExists,
    getBookingSubCategories,
    openScheduledBookingModal
};

export default injectIntl(withStyles(n, bt, s)(connect(mapState, mapDispatch)(ManualBookingForm)));
